import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import MemberApi from "../../../api/memebr.api";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import DelBtn from "../../../component/atoms/button/delBtn";
import EditBtn from "../../../component/atoms/button/editBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "../../../component/atoms/layout/table/tr";
import Th from "../../../component/atoms/layout/table/th";
import TableText from "../../../component/atoms/text/table/tableText";
import Td from "../../../component/atoms/layout/table/td";
import moment from "moment";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import Pagination from "../../../component/molecules/pagination";
import MyLectureModal from "../_component/myLectureModal";

const CommonMemberDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [memberInfo, setMemberInfo] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    getMemberInfo();
  }, []);

  const getMemberInfo = async () => {
    try {
      const response = (await MemberApi.getById(id)).data.data.content;

      setMemberInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await MemberApi.delete(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 수강 내역
  useEffect(() => {
    getLectureList();
  }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

  const [lectureList, setLectureList] = useState([]);

  const getLectureList = async () => {
    try {
      const data = {
        page: searchParams.get("page"),
        size: pagination.size,
        memberId: id,
      };
      let responseData = (await MemberApi.getLectureList(data)).data.data;

      setLectureList(
        responseData.content.map((item) => {
          return {
            ...item,
            lectureType: item.lectureVideoFlag ? getLectureType(item.lecture?.lectureCategoryType) : "컨설팅",
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  const getLectureType = (type) => {
    return type === "FINANCE_STUDY" ? "금융 스터디" : "유료 강의";
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
              <EditBtn
                onClick={() => {
                  navigate(route.user_common_member_edit + `/${id}`);
                }}
              />
            </div>
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>회원정보</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <DetailPageForm>
                <DetailFormTitle>최종 접속 시간</DetailFormTitle>
                <DetailFormText>{memberInfo.lastLoginDate ? moment(memberInfo.lastLoginDate).format("YYYY/MM/DD HH:mm:ss") : ""}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>유형</DetailFormTitle>
                <DetailFormText>{memberInfo.membership ? "구독회원" : "일반회원"}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>계정 상태</DetailFormTitle>
                <DetailFormText>{memberInfo.activation ? "활성" : "비활성"}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>가입일</DetailFormTitle>
                <DetailFormText>{moment(memberInfo.createdAt).format("YYYY/MM/DD")}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>아이디</DetailFormTitle>
                <DetailFormText>{memberInfo.account}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>닉네임</DetailFormTitle>
                <DetailFormText>{memberInfo.nickname}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{memberInfo.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>전화번호</DetailFormTitle>
                <DetailFormText>{memberInfo.phoneNumber}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>생년월일</DetailFormTitle>
                <DetailFormText>{memberInfo.birth}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이메일</DetailFormTitle>
                <DetailFormText>{memberInfo.email}</DetailFormText>
              </DetailPageForm>

              {/* 약관 동의 */}
              <DetailPageForm
                style={{
                  alignItems: "flex-start",
                }}
              >
                <DetailFormTitle>약관 동의</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <CheckboxWrapper>
                    <DetailFormText>만 14세 이상입니다 (필수)</DetailFormText>
                    <Checkbox id="fourteen" checked={true} disabled={true} />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>회원이용약관 (필수)</DetailFormText>
                    <Checkbox id="terms" checked={true} disabled={true} />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>개인정보 수집 및 이용동의 (필수)</DetailFormText>
                    <Checkbox id="terms" checked={true} disabled={true} />
                  </CheckboxWrapper>
                </div>
              </DetailPageForm>

              {/* 알림 수신 동의 */}
              <DetailPageForm
                style={{
                  alignItems: "flex-start",
                }}
              >
                <DetailFormTitle>알림 수신 동의</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <CheckboxWrapper>
                    <DetailFormText>이메일 및 SMS 마케팅정보수신 동의 (선택)</DetailFormText>
                    <Checkbox id="marketingInfo" checked={memberInfo.marketingAgreement} />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>광고성 정보 수신 동의 (선택)</DetailFormText>
                    <Checkbox id="marketingInfo" checked={memberInfo.adAgreement} />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>SMS 수신 동의 (선택)</DetailFormText>
                    <Checkbox id="marketingInfo" checked={memberInfo.smsAgreement} />
                  </CheckboxWrapper>
                </div>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>강의 수강 내역</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <Table
                style={{
                  width: 964,
                }}
              >
                <colgroup>
                  {/* 날짜/시간 */}
                  <col width="227px" />
                  {/* 유형 */}
                  <col width="105px" />
                  {/* 강의명 */}
                  <col width="366px" />
                  {/* 결제 금액 */}
                  <col width="109px" />
                  {/* 수강률 */}
                  <col width="80px" />
                  {/* 상세보기 */}
                  <col width="77px" />
                </colgroup>
                <thead>
                  <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                    <Th
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      <TableText>날짜/시간</TableText>
                    </Th>
                    <Th>
                      <TableText>유형</TableText>
                    </Th>
                    <Th>
                      <TableText>강의명</TableText>
                    </Th>
                    <Th>
                      <TableText>결제 금액</TableText>
                    </Th>
                    <Th>
                      <TableText>수강률</TableText>
                    </Th>
                    <Th>
                      <TableText>상세보기</TableText>
                    </Th>
                  </Tr>
                </thead>
                <tbody>
                  {lectureList.map((item, index) => {
                    return (
                      <Tr key={index} style={{ height: "59px", background: "#fff" }}>
                        <Td
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <TableText
                            style={{
                              width: 181,
                            }}
                          >
                            {moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss")}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText>{item.lectureType}</TableText>
                        </Td>
                        <Td>
                          <TableText
                            style={{
                              width: "366px",
                            }}
                          >
                            {item.payment?.lectureTitle}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText>{item.payment?.realPay.toLocaleString()}원</TableText>
                        </Td>
                        <Td>
                          <TableText>{item.progressPercent}%</TableText>
                        </Td>
                        <Td>
                          <DetailBtn
                            onClick={() => {
                              setSelectedData(item);
                              setDetailModalOpen(true);
                            }}
                          />
                        </Td>
                      </Tr>
                    );
                  })}
                </tbody>
              </Table>
              <Pagination route={route.user_common_member_detail + `/${id}`} queryString={""} currentPage={page} totalPages={pagination.totalPages} rangeSize={pagination.rangeSize} />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? <MyLectureModal data={selectedData} setModalOpen={setDetailModalOpen} /> : ""}
    </>
  );
};

export default CommonMemberDetail;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
